import { FormattedMessage, injectIntl } from 'react-intl'
import { Table, Flex, Button, Typography } from 'antd'
import debounce from 'lodash/debounce'
import { useHistory } from 'react-router-dom'

import Search from './Search'
import { requireAuthentication } from '../../helpers/authentication'
import { Loadable } from '../Loading'
import { isWindowBelowMinHeight } from '../../helpers/utils'

function TableBS(props) {
  const { Link } = Typography
  const history = useHistory()
  const { users = [], pagination = null } = props.usersData

  const columns = [
    {
      title: <FormattedMessage id="userList.email" />,
      width: '32%',
      render: (record) => {
        return (
          <Link
            className="edit-user-link"
            onClick={() => history.push(`users/${record.id}`)}
          >
            {record.email}
          </Link>
        )
      },
    },
    {
      title: <FormattedMessage id="userList.fullName" />,
      dataIndex: 'name',
      width: '33%',
    },
    {
      title: <FormattedMessage id="userList.role" />,
      dataIndex: 'role',
      ellipsis: true,
    },
    {
      title: <FormattedMessage id="userList.plants" />,
      render: (record) => {
        if (record.plants && record.plants.length > 0) {
          return record.plants.join(', ')
        }
        return ''
      },
    },
    {
      title: <FormattedMessage id="userList.disabled" />,
      render: (record) =>
        record.disabled ? (
          <FormattedMessage id="generic.yes" />
        ) : (
          <FormattedMessage id="generic.no" />
        ),
    },
  ]
  return (
    <div className="user-list-table-container">
      <Table
        dataSource={users}
        columns={columns}
        rowKey="id"
        pagination={{
          pageSize: isWindowBelowMinHeight() ? 10 : 13,
          hideOnSinglePage: true,
          showSizeChanger: false,
        }}
      />
    </div>
  )
}

function UserList(props) {
  const {
    users,
    externalProvider,
    isLoading,
    isMoreUsersLoading,
    loadUsersList,
    loadMoreUsers,
  } = props
  const history = useHistory()

  const query = users?.query
  const paginationToken = users?.pagination_token

  return (
    <Flex vertical={true} className="user-list-container" gap="large">
      <Flex vertical={false} justify="center" gap="large">
        {!externalProvider && (
          <Button
            type="primary"
            onClick={() => history.push(`/users/add`)}
            className="add-user-button"
          >
            <FormattedMessage id="users.addNewUser" />
          </Button>
        )}
        <Search
          makeSearchRequest={debounce((params) => loadUsersList(params), 250)}
          isLoading={isLoading}
          opts={{ query }}
        />
      </Flex>
      <Flex vertical={true} align="center">
        <Loadable isLoading={isLoading} showText={true}>
          <TableBS usersData={users} isLoading={isLoading} />
          {paginationToken ? (
            <Button
              type="primary"
              disabled={isMoreUsersLoading}
              onClick={() =>
                loadMoreUsers({ query, pagination: paginationToken })
              }
              className="load-more-data-button"
            >
              <FormattedMessage id="processes.loadMoreData" />
            </Button>
          ) : null}
        </Loadable>
      </Flex>
    </Flex>
  )
}

export default requireAuthentication(
  injectIntl(UserList),
  'page-user-administration:get',
)
